import httpClient from './httpClient';

const END_POINT = '/api/pack_country_domains';
const getAllPackCountryDomain = (perPage = null, page = null, sort = null, filterList = '') => {
    let pack_country_domainsApi = END_POINT;
    pack_country_domainsApi += filterList != '' ? '?' + filterList : '';
    pack_country_domainsApi += filterList == '' && perPage != null ? `?itemsPerPage= ${perPage} &page= ${page} ${sort}` : '';
    pack_country_domainsApi += filterList != '' && perPage != null ? `&itemsPerPage= ${perPage} &page= ${page} ${sort}` : '';
    return httpClient.get(pack_country_domainsApi);
};
const updatePackCountryDomain = (id, packCountryDomain) => httpClient.put(END_POINT + '/update/' + id, packCountryDomain);
const addPackCountryDomain = packCountryDomain => httpClient.post(END_POINT + '/add', packCountryDomain);

const deletePackCountryDomains = (idDomain, idCountry) => httpClient.delete(`${END_POINT}/delete/${idDomain}/${idCountry}`);

const getPackCountryDomainWithFilter = id => httpClient.get(END_POINT + '/' + id);

const getPackCountryDomain = (domain_name, country_code, type, getDisabled) =>
    httpClient.post(END_POINT + '/byDomain&Country', {domain_name, country_code, type, getDisabled});

export {
    getAllPackCountryDomain,
    getPackCountryDomain,
    getPackCountryDomainWithFilter,
    updatePackCountryDomain,
    addPackCountryDomain,
    deletePackCountryDomains
};
